<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-md-12">
      <!-- Breadcrumb Navigation -->
      <nav
        class="d-flex align-items-center flex-wrap gap-2 mb-3"
        aria-label="breadcrumb"
      >
        <div class="d-flex align-items-center">
          <mat-icon class="me-3" color="primary"
            >miscellaneous_services</mat-icon
          >
          <p class="fw-semibold mb-0" style="font-size: 20px">
            {{
              "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.EMAIL_CON"
                | translate
            }}
          </p>
        </div>

        <span class="text-secondary mx-2">/</span>
        <span class="text-secondary">{{
          "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Send_Test_Message"
            | translate
        }}</span>
      </nav>
    </div>
    <div class="col-md-12">
      <div class="card shadow-sm">
        <!-- Tabs -->
        <ul class="nav nav-tabs px-3 pt-2" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="activeTab === 'email'"
              (click)="setTab('email')"
            >
              {{ "ATTRIBUTES.MODAL.TABS.Email" | translate }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="activeTab === 'general'"
              (click)="setTab('general')"
            >
              {{ "ATTRIBUTES.MODAL.TABS.General" | translate }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="activeTab === 'server'"
              (click)="setTab('server')"
            >
              {{ "ATTRIBUTES.MODAL.TABS.Server" | translate }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="activeTab === 'payment'"
              (click)="setTab('payment')"
            >
              {{ "ATTRIBUTES.MODAL.TABS.Payment" | translate }}
            </button>
          </li>
        </ul>

        <!-- Tab Content -->
        <div class="card-body p-4">
          <!-- Email Tab -->
          <div *ngIf="activeTab === 'email'">
            <div
              class="settings-section-header d-flex align-items-center gap-2 mb-4"
            >
              <div class="settings-section-icon icon-blue">
                <i class="bi bi-envelope"></i>
              </div>
              <div>
                <h6 class="fw-semibold mb-0">
                  {{
                    "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.EMAIL"
                      | translate
                  }}
                </h6>
                <small class="text-muted">{{
                  "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.EMAIL_DETAIL"
                    | translate
                }}</small>
              </div>
            </div>
            <div class="row g-3">
              <div class="col-md-4">
                <a
                  [routerLink]="['/emailconfiguration', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-blue mb-2">
                    <i class="bi bi-gear"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1 mail-title"
                    style="font-size: 13px"
                  >
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.EMAIL_CON"
                        | translate
                    }}
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.EMAIL_CONFIG_DETAIL"
                        | translate
                    }}
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_CONFIGURATION_DETAILS.Configure"
                        | translate
                    }}
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  [routerLink]="['/emailtemplate', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-teal mb-2">
                    <i class="bi bi-file-earmark-text"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1 mail-title"
                    style="font-size: 13px"
                  >
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Email_Templates"
                        | translate
                    }}
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Design" | translate
                    }}
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    {{
                      "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Manage_Templates"
                        | translate
                    }}
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  [routerLink]="['/testemail', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-amber mb-2">
                    <i class="bi bi-send"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1 mail-title"
                    style="font-size: 13px"
                  >
                    {{
                      "EMAIL_CONFIGURATION.Compose_Test_Email.Test_Email"
                        | translate
                    }}
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    {{
                      "EMAIL_CONFIGURATION.Compose_Test_Email.Send_Test_Email"
                        | translate
                    }}
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    {{
                      "EMAIL_CONFIGURATION.Compose_Test_Email.Send_Test"
                        | translate
                    }}
                  </div>
                </a>
              </div>
            </div>
          </div>

          <!-- General Tab -->
          <div *ngIf="activeTab === 'general'">
            <div
              class="settings-section-header d-flex align-items-center gap-2 mb-4"
            >
              <div class="settings-section-icon icon-blue">
                <i class="bi bi-sliders"></i>
              </div>
              <div>
                <h6 class="fw-semibold mb-0">General</h6>
                <small class="text-muted"
                  >Application-wide settings and preferences</small
                >
              </div>
            </div>
            <!-- <div class="row g-3">
              <div class="col-md-4">
                <a
                  [routerLink]="['/generalsettings', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-blue mb-2">
                    <i class="bi bi-toggles"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1"
                    style="font-size: 13px"
                  >
                    App Settings
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    Manage app name, timezone, and locale
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    Configure
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  [routerLink]="['/security', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-coral mb-2">
                    <i class="bi bi-shield-lock"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1"
                    style="font-size: 13px"
                  >
                    Security
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    Password policies, 2FA, and session controls
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    Manage
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  [routerLink]="['/notifications', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-amber mb-2">
                    <i class="bi bi-bell"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1"
                    style="font-size: 13px"
                  >
                    Notifications
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    Configure alerts, webhooks, and rules
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    Set up
                  </div>
                </a>
              </div>
            </div> -->
          </div>

          <!-- Server Tab -->
          <div *ngIf="activeTab === 'server'">
            <div
              class="settings-section-header d-flex align-items-center gap-2 mb-4"
            >
              <div class="settings-section-icon icon-purple">
                <i class="bi bi-hdd-rack"></i>
              </div>
              <div>
                <h6 class="fw-semibold mb-0">Server</h6>
                <small class="text-muted"
                  >Server configuration, monitoring, and infrastructure</small
                >
              </div>
            </div>
            <!-- <div class="row g-3">
              <div class="col-md-4">
                <a
                  [routerLink]="['/serverconfig', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-purple mb-2">
                    <i class="bi bi-cpu"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1"
                    style="font-size: 13px"
                  >
                    Server Configuration
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    Host, port, environment, and runtime settings
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    Configure
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  [routerLink]="['/serverlogs', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-teal mb-2">
                    <i class="bi bi-terminal"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1"
                    style="font-size: 13px"
                  >
                    Server Logs
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    View real-time logs, errors, and audit trails
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    View logs
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  [routerLink]="['/serverstatus', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-green mb-2">
                    <i class="bi bi-bar-chart-line"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1"
                    style="font-size: 13px"
                  >
                    Health & Status
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    Uptime, resource usage, and health checks
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    Monitor
                  </div>
                </a>
              </div>
            </div> -->
          </div>

          <!-- Payment Tab -->
          <div *ngIf="activeTab === 'payment'">
            <div
              class="settings-section-header d-flex align-items-center gap-2 mb-4"
            >
              <div class="settings-section-icon icon-green">
                <i class="bi bi-credit-card"></i>
              </div>
              <div>
                <h6 class="fw-semibold mb-0">
                  {{ "PaymentS.Payment" | translate }}
                </h6>
                <small class="text-muted">{{
                  "PaymentS.Gateway_Settings" | translate
                }}</small>
              </div>
            </div>
            <div class="row g-3">
              <div class="col-md-4">
                <a
                  [routerLink]="['/paymentconfiguration', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-purple mb-2">
                    <i class="bi bi-credit-card"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1 mail-title"
                    style="font-size: 13px"
                  >
                    {{ "PaymentS.Payment_configuration" | translate }}
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    {{ "PaymentS.Payment_Details" | translate }}
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    {{ "PaymentS.Configure" | translate }}
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  [routerLink]="['/testpayemtdateway', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-coral mb-2">
                    <i class="bi bi-activity"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1 mail-title"
                    style="font-size: 13px"
                  >
                    {{ "PaymentS.TestPaymentGateway" | translate }}
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    {{ "PaymentS.Run_Test" | translate }}
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    {{ "PaymentS.RunT" | translate }}
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  [routerLink]="['/myorders', applicationId]"
                  class="settings-link-card text-decoration-none d-block p-3 rounded-3 border h-100"
                >
                  <div class="settings-card-icon icon-green mb-2">
                    <i class="bi bi-bag"></i>
                  </div>
                  <div
                    class="fw-semibold text-body mb-1 mail-title"
                    style="font-size: 13px"
                  >
                    {{ "PaymentS.My_Order" | translate }}
                  </div>
                  <div
                    class="text-muted"
                    style="font-size: 12px; line-height: 1.4"
                  >
                    {{ "PaymentS.My_order_Details" | translate }}
                  </div>
                  <div
                    class="mt-2 d-flex align-items-center gap-1 text-muted"
                    style="font-size: 11px"
                  >
                    <i class="bi bi-chevron-right" style="font-size: 10px"></i>
                    {{ "PaymentS.View_Order" | translate }}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Test Email Modal -->
<div
  class="modal fade"
  id="testEmailModal"
  tabindex="-1"
  aria-labelledby="testEmailModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="testEmailModalLabel">Send Test Email</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <form #testEmailForm="ngForm">
          <div class="mb-3">
            <label for="testEmail" class="form-label">Recipient Email</label>
            <input
              type="email"
              class="form-control"
              id="testEmail"
              name="testEmail"
              [(ngModel)]="form.data.testEmail"
              placeholder="example@email.com"
              required
            />
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="sendTestEmail()"
          [disabled]="!form.data.testEmail"
          data-bs-dismiss="modal"
        >
          Send
        </button>
      </div>
    </div>
  </div>
</div>
